
import React from 'react';
import { FormFieldType } from '@/types/form';
import FormField from '../FormField';

interface DevelopmentSectionProps {
  elementGroups: {
    topicElements: FormFieldType[];
    knowledgeElements: FormFieldType[];
    skillsElements: FormFieldType[];
    attitudeElements: FormFieldType[];
    otherElements: FormFieldType[];
  };
  documentUrls?: string[];
}

const DevelopmentSection: React.FC<DevelopmentSectionProps> = ({ 
  elementGroups,
  documentUrls = []
}) => {
  const { topicElements, knowledgeElements, skillsElements, attitudeElements, otherElements } = elementGroups;
  
  return (
    <div className="space-y-8">
      <div className="space-y-6">
        {topicElements.map((element) => (
          <div key={element.id}>
            <FormField element={element} documentUrls={documentUrls} />
          </div>
        ))}
      </div>
      
      <div className="space-y-6 p-4 bg-gray-50 rounded-lg border border-gray-200">
        <h3 className="text-lg font-medium text-gray-900">มิติความรู้ (Knowledge)</h3>
        {knowledgeElements.map((element) => (
          <div key={element.id}>
            <FormField element={element} />
          </div>
        ))}
      </div>
      
      <div className="space-y-6 p-4 bg-gray-50 rounded-lg border border-gray-200">
        <h3 className="text-lg font-medium text-gray-900">มิติทักษะ (Skills)</h3>
        {skillsElements.map((element) => (
          <div key={element.id}>
            <FormField element={element} />
          </div>
        ))}
      </div>
      
      <div className="space-y-6 p-4 bg-gray-50 rounded-lg border border-gray-200">
        <h3 className="text-lg font-medium text-gray-900">มิติทัศนคติ (Attitude)</h3>
        {attitudeElements.map((element) => (
          <div key={element.id}>
            <FormField element={element} />
          </div>
        ))}
      </div>
      
      <div className="space-y-6">
        {otherElements.map((element) => (
          <div key={element.id}>
            <FormField element={element} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default DevelopmentSection;
